import SnProductMappingStatusBadge from '#/modules/crmMgmt/aftersales/snProductMapping/components/SnProductMappingStatusBadge';

export const snProductMappingSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <SnProductMappingStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

export const snProductMappingSideMsgDetailBlock = {
  fields: [
    { label: '產品代碼', value: 'productCode' },
    { label: '產品名稱', value: 'productName' },
    {
      label: '客戶',
      value: (row) => (row?.customerId ? '已指定' : '未指定'),
    },
    { label: '備註', value: 'remark' },
  ],
};
